import { createColumnHelper } from '@tanstack/react-table';

import { Report } from 'types/report';
import { calculateLost } from 'utils/calculateLost';
import { calHarvestRate } from 'utils/harvestSummaryUtils';

const col = createColumnHelper<Report>();

/** Single-SKU orders show that SKU's case count; multi-SKU orders sum. */
export const reportReturned = (report: Report) =>
  report?.details?.reduce(
    (acc: number, cur: any) => acc + Number(cur.ret || '0'),
    0,
  );

export const reportLost = (report: Report) =>
  report?.details?.reduce(
    (acc: number, cur: any) => acc + calculateLost(cur),
    0,
  );

/** Truncates the site name to 15 characters — matches the previous manual slice. */
export const siteNameTruncated = (report: Report) =>
  report?.site?.name && report.site.name.length > 15
    ? `${report.site.name.slice(0, 15)}...`
    : report?.site?.name || '-';

export const buildHarvestSummaryColumns = () => [
  col.accessor((report) => report?.reportNo || '-', {
    id: 'reportNo',
    header: 'Harvest No',
    minSize: 90,
  }),
  col.accessor((report) => siteNameTruncated(report), {
    id: 'site',
    header: 'Site',
    minSize: 150,
    meta: { sortField: 'site.name' },
  }),
  col.accessor((report) => report?.name || '-', {
    id: 'name',
    header: 'Name',
    minSize: 150,
  }),
  col.accessor(
    (report) => {
      const returned = reportReturned(report);
      return returned ? returned : '-';
    },
    {
      id: 'returned',
      header: 'Items Returned',
      minSize: 100,
      meta: { align: 'center' },
    },
  ),
  col.accessor((report) => reportLost(report), {
    id: 'lost',
    header: 'Lost Count',
    minSize: 90,
    meta: { align: 'center' },
  }),
  col.accessor((report) => `${calHarvestRate(report)}%`, {
    id: 'harvestRate',
    header: 'Harvest Rate',
    minSize: 100,
    meta: { align: 'center' },
  }),
];
